import type { FaireProductEntity } from "../../entity_types/product";

export const p_x9zun5pes8: FaireProductEntity = {
  token: "p_x9zun5pes8",
  type: "product",
  name: "Bear Figurine Small Carved Gemstone – Crystal Animal Totem",
  brandToken: "b_at4bwf6pjp",
  brandName: "Keystone Crystals",
  imageUrl: "https://cdn.faire.com/fastly/3b94f340cc1083c2c482ad1cc7c7e22f35edc24dc3dee283ba3333f967aca8ee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/12d5337843f7a4b5efae54745e3b844f78232fbf5af80b36e695dfb936e4d1de.jpeg",
    "https://cdn.faire.com/fastly/be6961c408c1977d53150edf9d13c1e298da12f0edaa3f9d56ea5d3d415abbc1.jpeg",
    "https://cdn.faire.com/fastly/bb41de07d24e2b5dd4edaaab890db72ad928a70554f7d762a1e87cdb65af4fc5.jpeg",
    "https://cdn.faire.com/fastly/f347c1d453fa755fed8ccbfd729ed7cd14b0ab48bcb8f5ebd1d505eff53ca5b5.jpeg",
    "https://cdn.faire.com/fastly/a7588d4c77c5ce9856f979073d0a6e47ff6eeeb88039f4acaf08c7c894297049.jpeg",
    "https://cdn.faire.com/fastly/980c2675cc88d928f09c5b23c4d71c69e8c505fd52d56187ccb132d3037f44fb.jpeg",
    "https://cdn.faire.com/fastly/2b7bece8dd8bab6362c71f4148a63433a1f1df4aeb9a8fd190f9f7f0bca6f357.jpeg",
    "https://cdn.faire.com/fastly/07d3a7c7c2bf16e41c5261592078560bff2a415738c4039ec3df2be1e959afd0.jpeg",
    "https://cdn.faire.com/fastly/22946c25ecea1379a9e76689dc983b4d7cf841535afa87ab9bec9023d32f7cba.jpeg",
    "https://cdn.faire.com/fastly/aaaf44f7789d7d578eb264c7530589cad06e2af2d02191df6cf3329c3422b2c7.jpeg",
    "https://cdn.faire.com/fastly/a4fe121689e7e0ae1e1d232dd5e5f186bd5c32a1682c61e406b220a299f2d5fe.jpeg",
    "https://cdn.faire.com/fastly/baf2ba30e5eed713f35365173d4415cb2adce75446ea9a8fe0cc1fed0af63c34.jpeg",
    "https://cdn.faire.com/fastly/e84ea5db261accf4544822cf82d42f429acd863401085c9a804c19eeb6b883a5.jpeg",
    "https://cdn.faire.com/fastly/f779bef7147355d642a8890112ea88fcd17e5f3ee18bc0e3842c6b1636a721c9.jpeg"
  ],
  priceDollars: 3.19,
  description: "Bring strength, grounding, and protection into your inventory with these small carved gemstone bear figurines. Each crystal bear is carved from gemstone, symbolizing courage, stability, and connection to the Earth. Perfect for metaphysical shops, crystal retailers, and gift boutiques, these mini animal totems are ideal for display, resale, or inclusion in spiritual gift sets. Each gemstone bear figurine carries its own natural color and energy signature, making it a unique addition to your wholesale crystal collection. \n\nSold individually with a minimum of 3 per style.\n",
  tags: [],
  msrpDollars: 6.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:02.935Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
